<template>
    <div style="background-color:#f7f8fa">
        <van-nav-bar
            :title="title"
            left-text="返回"
            left-arrow
            right-text="筛选"
            @click-left="onClickLeft"
            @click-right="onClickRight"
            />
        <van-tabs v-model="active" sticky>
            <van-tab>
                <template #title> 
                    流程中
                    <a-badge :count="totalSize">
                    </a-badge>   
                </template>
                <van-list
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                    @load="onLoad"
                    >
                    <van-cell  v-for="item in list" :key="item" style="background-color:#f7f8fa">
                        <template #title> 
                            <a-card :title="'会议名称：'+item.meetingName" :bordered="false" style="width: 100%;" @click="info(item,'commit')" v-if="type.startsWith('meeting')">
                                <p slot="extra" style="color:#52c41a">流程中</p>
                                    <div class="item">
                                        <p>会议时间：</p>
                                        <div class="text">{{item.startTime.substr(0,16)}}至{{item.endTime.substr(0,16)}}</div>
                                    </div>
                                    <div class="item">
                                        <p>会议室：</p>
                                        <div class="text">{{item.roomName}}</div>
                                    </div>
                                    <div class="item">
                                        <p>预约人：</p>
                                        <div class="text">{{item.orderPeople}}({{item.orderPeoplePhone}})</div>
                                    </div>
                                    <div class="item">
                                        <p>申请时间：</p>
                                        <div class="text">{{item.createTime}}</div>
                                    </div>
                            </a-card>
                            <a-card :title="'用章事由：'+item.targetUse" :bordered="false" style="width: 100%;" @click="info(item,'commit')" v-if="type.startsWith('seal')">
                                <p slot="extra" style="color:#52c41a">流程中</p>
                                <div class="item">
                                    <p>用章类型：</p>
                                    <div class="text">{{item.type}}</div>
                                </div>
                                <div class="item">
                                    <p>申请人：</p>
                                    <div class="text">{{item.teacherName}}</div>
                                </div>
                                <div class="item">
                                    <p>申请日期：</p>
                                    <div class="text">{{item.createTime}}</div>
                                </div>
                            </a-card>
                        </template>
                    </van-cell>
                </van-list>
            </van-tab>
            <van-tab>
                <template #title> 
                    办结
                    <a-badge :count="endTotalSize">
                    </a-badge>   
                </template>
                <van-list
                    v-model="endLoading"
                    :finished="endFinished"
                    finished-text="没有更多了"
                    @load="endOnLoad"
                    >
                    <van-cell  v-for="item in endList" :key="item" style="background-color:#f7f8fa">
                        <template #title> 
                            <a-card :title="'会议名称：'+item.meetingName" :bordered="false" style="width: 100%;" @click="info(item,'end')" v-if="type.startsWith('meeting')">
                                <p slot="extra" style="color:#52c41a">办结</p>
                                <div class="item">
                                    <p>会议时间：</p>
                                    <div class="text">{{item.startTime.substr(0,16)}}至{{item.endTime.substr(0,16)}}</div>
                                </div>
                                <div class="item">
                                    <p>会议室：</p>
                                    <div class="text">{{item.roomName}}</div>
                                </div>
                                <div class="item">
                                    <p>预约人：</p>
                                    <div class="text">{{item.orderPeople}}({{item.orderPeoplePhone}})</div>
                                </div>
                                <div class="item">
                                    <p>申请时间：</p>
                                    <div class="text">{{item.createTime}}</div>
                                </div>
                            </a-card>
                            <a-card :title="'用章事由：'+item.targetUse" :bordered="false" style="width: 100%;" @click="info(item,'end')" v-if="type.startsWith('seal')">
                                <p slot="extra" style="color:#52c41a">办结</p>
                                <div class="item">
                                    <p>用章类型：</p>
                                    <div class="text">{{item.type}}</div>
                                </div>
                                <div class="item">
                                    <p>申请人：</p>
                                    <div class="text">{{item.teacherName}}</div>
                                </div>
                                <div class="item">
                                    <p>申请日期：</p>
                                    <div class="text">{{item.createTime}}</div>
                                </div>
                            </a-card>
                        </template>
                    </van-cell>
                </van-list>
            </van-tab>
        </van-tabs>
        <van-popup position="top" :style="{ height: '25%',width:'100%' }" v-model="show">
            <!-- <van-cell :title="dateTitle" :value="date" @click="dateShow = true" /> -->
            <van-calendar  :min-date="minDate" :max-date="maxDate"  v-model="dateShow" type="range" @confirm="onConfirm" :show-confirm="false"/>
            <van-cell-group>
                <van-field v-model="date" readonly label="使用时间" >
                    <template #button>
                        <van-button size="small" @click="dateShow = true" type="primary">选择时间</van-button>
                    </template>
                </van-field>
            </van-cell-group>

            <van-cell-group>
                <van-field v-model="roomName" readonly label="会议室" >
                    <template #button>
                        <van-button size="small" @click="meetingSelect" type="primary">选择会议室</van-button>
                    </template>
                </van-field>
            </van-cell-group>
            <van-button size="large" style="margin:10px 0px 0px 0px" @click="select" type="primary">确定</van-button>
            <van-sticky :offset-top="400">
                <van-picker
                v-show="meetingShow"
                title="会议室选择"
                show-toolbar
                :columns="meetingColumns"
                @confirm="onMeetingConfirm"
                @cancel="onMeetingCancel"
                @change="onMeetingChange"
                />
            </van-sticky>   
        </van-popup>
        <van-popup position="top" :style="{ height: '25%',width:'100%' }" v-model="sealShow">
            <!-- <van-cell :title="dateTitle" :value="date" @click="dateShow = true" /> -->
            <van-calendar  :min-date="minDate" :max-date="maxDate"  v-model="sealDateShow" type="range" @confirm="onSealConfirm" :show-confirm="false"/>
            <van-cell-group>
                <van-field v-model="sealDate" readonly label="申请时间" >
                    <template #button>
                        <van-button size="small" @click="sealDateShow = true" type="primary">选择时间</van-button>
                    </template>
                </van-field>
            </van-cell-group>
            <van-cell-group>
                <van-field v-model="sealType" readonly label="公章类型" >
                    <template #button>
                        <van-button size="small" @click="sealSelect" type="primary">选择类型</van-button>
                    </template>
                </van-field>
            </van-cell-group>
            <van-button size="large" style="margin:10px 0px 0px 0px" @click="select" type="primary">确定</van-button>
            <van-sticky :offset-top="400">
                <van-picker
                v-show="sealTypeShow"
                title="公章类型选择"
                show-toolbar
                :columns="selaTypeList"
                @confirm="onSealTypeConfirm"
                @cancel="onSealCancel"
                @change="onSealChange"
                />
            </van-sticky>   
        </van-popup>
        
    </div>
    
</template>
<script>
import { sealTodo,meetingApply,meetingTodo,sealApply } from '@/baseAPI/mobile/mobile'
import { getDicts } from '@/baseAPI/dictionary'
export default {
    name: '',
    data () {
        return {
            size: 5,
            current: 0,
            totalPages: 1,
            totalSize: 0,
            list: [],
            endList:[],
            loading: false,
            finished: false,
            title:'',
            type:'',
            status:'',
            endCurrent: 0,
            endTotalPages: 1,
            endTotalSize: 0,
            endLoading: false,
            endFinished: false,
            active:0,
            show: false,
            dateShow:false,
            date: '',
            dateTitle:'',
            roomName:'',
            sealType:'',
            roomId:'',
            meetingColumns: [],
            meetingShow:false,
            meetingRoomDics:[],
            meetingStartTime:'',
            meetingEndTime:'',
            selaTypeList:['行政公章','党章'],
            sealDate:'',
            sealShow:false,
            sealTypeShow:false,
            sealDateShow:false,
            minDate: new Date(2010, 0, 1),
            maxDate: new Date(2050, 0, 31),
        }
    },
    mounted () {
        this.type = this.$route.query.type;
        if(this.type == 'sealApply'){
            this.title = "用印-我的申请"
            this.status = "commit"
            this.endOnLoad()
        }else if(this.type == 'sealApplyEnd'){
            this.title = "用印-我的申请"
            this.status = "end"
            this.active = 1
            this.onLoad()
        }else if(this.type == 'meetingApply'){
            this.title = "会议室-我的申请"
            this.status = "commit"
            this.endOnLoad()
            this.dateTitle = '会议室申请使用时间'
        }else if(this.type == 'meetingApplyEnd'){
            this.title = "会议室-我的申请"
            this.status = "end"
            this.active = 1
            this.onLoad()
            this.dateTitle = '会议室申请使用时间'
        }else if(this.type == 'sealTodo'){
            this.title = "用印-我的审批"
            this.status = "commit"
            this.endOnLoad()
        }else if(this.type == 'sealTodoEnd'){
            this.title = "用印-我的审批"
            this.status = "end"
            this.active = 1
            this.onLoad()
        }else if(this.type == 'meetingTodo'){
            this.title = "会议室-我的审批"
            this.status = "commit"
            this.endOnLoad()
            this.dateTitle = '会议室申请使用时间'
        }else if(this.type == 'meetingTodoEnd'){
            this.title = "会议室-我的审批"
            this.status = "end"
            this.active = 1
            this.onLoad()
            this.dateTitle = '会议室申请使用时间'
        }

        getDicts({dataCode:'HYS',status:true}).then(res=>{
            this.meetingRoomDics=res.data.dicts;
            res.data.dicts.forEach(e=>{
                this.meetingColumns.push(e.dataName)
            })
        })
        
        
    },
    methods:{
        select(){
            if(this.active==0){
                this.current=0
                this.totalPages=1
                this.list=[]
                this.onLoad() 
            }else if(this.active==1){
                this.endCurrent=0
                this.endTotalPages=1
                this.endList=[]
                this.endOnLoad()
            }
            this.show=false
            this.sealShow=false
        },
        sealSelect(){
            this.sealTypeShow = true
        },
        onSealTypeConfirm(value, index) {
            this.sealTypeShow = false
            this.sealType=value
        },
        onSealChange(picker, value, index) {
        },
        onSealCancel() {
            this.sealShow = false
        },
        onSealConfirm(date) {
            const [start, end] = date;
            this.sealDateShow = false;
            this.sealStartTime = this.formatFullDate(start)
            this.sealEndTime = this.formatFullDate(end).substr(0,10) + ' 23:59:59'
            this.sealDate = `${this.formatDate(start)} - ${this.formatDate(end)}`;
        },
        meetingSelect(){
            this.meetingShow = true
        },
        onMeetingConfirm(value, index) {
            this.meetingShow = false
            this.roomName=value
            this.roomId = this.meetingRoomDics.filter(item => item.dataName == value)[0].dataCode;
        },
        onMeetingChange(picker, value, index) {
        },
        onMeetingCancel() {
            this.meetingShow = false
        },
        formatDate(date) {
            return `${date.getMonth() + 1}/${date.getDate()}`;
        },
        onConfirm(date) {
            const [start, end] = date;
            this.dateShow = false;
            this.meetingStartTime = this.formatFullDate(start)
            this.meetingEndTime = this.formatFullDate(end).substr(0,10) + ' 23:59:59'
            this.date = `${this.formatDate(start)} - ${this.formatDate(end)}`;
        },
        onClickRight() {
            if(this.type.indexOf("seal") > -1){
                this.sealShow = true;
            }else if(this.type.indexOf("meeting") > -1){
                this.show = true;
            }
            
        },
        info(item,type){
           if(type == 'commit'){
                this.type = this.type.replace('End','')
            }else if(type == 'end'){
                if(!this.type.endsWith("End")){
                    this.type = this.type + 'End'
                }
            }
            this.$router.push('/mobile/info?item='+JSON.stringify(item)+'&type='+this.type)
        },
        onClickLeft(){
            this.$router.go(-1);
        },
        formatFullDate (date) {
            let myyear = date.getFullYear();
            let mymonth = date.getMonth() + 1;
            let myweekday = date.getDate();
            let myHour = date.getHours();
            let myMin = date.getMinutes();
            let mySec = date.getSeconds();

            if (mymonth < 10) {
                mymonth = '0' + mymonth;
            }
            if (myweekday < 10) {
                myweekday = '0' + myweekday;
            }
            if (myHour < 10) {
                myHour = '0' + myHour;
            }
            if (myMin < 10) {
                myMin = '0' + myMin;
            }
            if (mySec < 10) {
                mySec = '0' + mySec;
            }
            return (myyear + '-' + mymonth + '-' + myweekday + ' ' + myHour + ':' + myMin + ':' + mySec);
        },
        onLoad() {
            this.current = this.current + 1;
            if(this.current <= this.totalPages){
                if(this.type.startsWith("meetingApply")){
                    meetingApply({size:this.size,current:this.current,status:"commit",roomId:this.roomId,startTime:this.meetingStartTime,endTime:this.meetingEndTime}).then(res=>{
                        this.totalPages = res.data.pages;
                        this.totalSize = res.data.total
                        res.data.records.forEach(element => {
                            this.list.push(element)
                        });
                        this.loading = false;
                        if (this.list.length >= this.totalSize) {
                            this.finished = true;
                        }
                    })
                }else if(this.type.startsWith("sealApply")){
                    sealApply({size:this.size,current:this.current,status:"commit",type:this.sealType,startDate:this.sealStartTime,endDate:this.sealEndTime}).then(res=>{
                        this.totalPages = res.data.pages;
                        this.totalSize = res.data.total
                        res.data.records.forEach(element => {
                            this.list.push(element)
                        });
                        this.loading = false;
                        if (this.list.length >= this.totalSize) {
                            this.finished = true;
                        }
                    })
                }else if(this.type.startsWith("meetingTodo")){
                    meetingTodo({size:this.size,current:this.current,status:"commit",roomId:this.roomId,startTime:this.meetingStartTime,endTime:this.meetingEndTime}).then(res=>{
                        this.totalPages = res.data.pages;
                        this.totalSize = res.data.total
                        res.data.records.forEach(element => {
                            this.list.push(element)
                        });
                        this.loading = false;
                        if (this.list.length >= this.totalSize) {
                            this.finished = true;
                        }
                    })
                }else if(this.type.startsWith("sealTodo")){
                    sealTodo({size:this.size,current:this.current,status:"commit",type:this.sealType,startDate:this.sealStartTime,endDate:this.sealEndTime}).then(res=>{
                        this.totalPages = res.data.pages;
                        this.totalSize = res.data.total
                        res.data.records.forEach(element => {
                            this.list.push(element)
                        });
                        this.loading = false;
                        if (this.list.length >= this.totalSize) {
                            this.finished = true;
                        }
                    })
                }
                
            }
        },
        endOnLoad() {
            this.endCurrent = this.endCurrent + 1;
            if(this.endCurrent <= this.endTotalPages){
                if(this.type.startsWith("meetingApply")){
                    meetingApply({size:this.size,current:this.endCurrent,status:"end",roomId:this.roomId,startTime:this.meetingStartTime,endTime:this.meetingEndTime}).then(res=>{
                        this.endTotalPages = res.data.pages;
                        this.endTotalSize = res.data.total;
                        res.data.records.forEach(element => {
                            this.endList.push(element)
                        });
                        this.endLoading = false;
                        if (this.endList.length >= this.endTotalSize) {
                            this.endFinished = true;
                        }
                    })
                }else if(this.type.startsWith("sealApply")){
                    sealApply({size:this.size,current:this.endCurrent,status:"end",type:this.sealType,startDate:this.sealStartTime,endDate:this.sealEndTime}).then(res=>{
                        this.endTotalPages = res.data.pages;
                        this.endTotalSize = res.data.total;
                        res.data.records.forEach(element => {
                            this.endList.push(element)
                        });
                        this.endLoading = false;
                        if (this.endList.length >= this.endTotalSize) {
                            this.endFinished = true;
                        }
                    })
                }else if(this.type.startsWith("meetingTodo")){
                    meetingTodo({size:this.size,current:this.endCurrent,status:"end",roomId:this.roomId,startTime:this.meetingStartTime,endTime:this.meetingEndTime}).then(res=>{
                        this.endTotalPages = res.data.pages;
                        this.endTotalSize = res.data.total;
                        res.data.records.forEach(element => {
                            this.endList.push(element)
                        });
                        this.endLoading = false;
                        if (this.endList.length >= this.endTotalSize) {
                            this.endFinished = true;
                        }
                    })
                }else if(this.type.startsWith("sealTodo")){
                    sealTodo({size:this.size,current:this.endCurrent,status:"end",type:this.sealType,startDate:this.sealStartTime,endDate:this.sealEndTime}).then(res=>{
                        this.endTotalPages = res.data.pages;
                        this.endTotalSize = res.data.total;
                        res.data.records.forEach(element => {
                            this.endList.push(element)
                        });
                        this.endLoading = false;
                        if (this.endList.length >= this.endTotalSize) {
                            this.endFinished = true;
                        }
                    })
                }
            }
        },
    }
}
</script>
<style scoped>
.item{
    display: flex;
}
.item p{
    text-align: right;
    width: 70px;
}
.item .text{
    width: calc(100% - 70px);
}
</style>